// Messages
// Product List
export const Add_Product_ToastSuccessMessage = 'Product Successfully Added';
export const Update_Product_ToastSuccessMessage = 'Product Successfully Updated';
export const Delete_Product_ToastSuccessMessage = 'Product Successfully Deleted';
export const Share_Product_ToastSuccessMessage = 'Product Successfully Shared';


export const Add_Product_ToastFailMessage = 'Product Fail to Add';
export const Update_Product_ToastFailMessage = 'Product Fail to Update';
export const Delete_Product_ToastFailMessage = 'Product Fail to Delete';
export const Share_Product_ToastFailMessage = 'Product Fail to Share';

// Orders Notification 

export const Delivered_Order_ToastSuccessMessage = 'Order Delivered';
export const Pending_Order_ToastSuccessMessage = 'Order Pending';
export const Progress_Order_ToastSuccessMessage = 'In Progress';
export const Cancel_Order_ToastSuccessMessage = 'Order Canceled';

export const Delivered_Order_ToastFailMessage = 'Order Failed to Make Changes';
export const Pending_Order_ToastFailMessage = 'Order Failed to Make Changes';
export const Cancel_Order_ToastFailMessage = 'Order Failed to Make Changes';

// Enquiry Notification
export const Pending_Enq_ToastSuccessMessage = 'Enquiry Pending';
export const Progress_Enq_ToastSuccessMessage = 'Enquiry In Progress';
export const Done_Enq_ToastSuccessMessage = 'Enquiry Done';

export const Pending_Enq_ToastFailMessage = 'Enquiry Failed to Edit';
export const Done_Enq_ToastFailMessage = 'Enquiry Failed to Edit';



// Categories Notification
export const Add_Cat_ToastSuccessMessage = 'Category Successfully Added';
export const Update_Cat_ToastSuccessMessage = 'Category Successfully Updated';
export const Delete_Cat_ToastSuccessMessage = 'Category Successfully Deleted';

export const Add_Cat_ToastFailMessage = 'Category Failed to Added';
export const Update_Cat_ToastFailMessage = 'Category Fail to Update';
export const Delete_Cat_ToastFailMessage = 'Category Fail to Delete';

// Customer Notification
export const Add_Cust_ToastSuccessMessage = 'Customer Successfully Added';
export const Update_Cust_ToastSuccessMessage = 'Customer Successfully Updated';
export const Delete_Cust_ToastSuccessMessage = 'Customer Successfully Deleted';

export const Add_Cust_ToastFailMessage = 'Customer Failed to Added';
export const Update_Cust_ToastFailMessage = 'Customer Fail to Update';
export const Delete_Cust_ToastFailMessage = 'Customer Fail to Delete';

